import { IAuthState } from './interfaces';

export const authSelectors = {
    isAuthenticated: (state: IAuthState) => state.authenticated,

    getToken: (state: IAuthState) => state.token,
};
